import { connect } from 'react-redux'
import PassDetails from './PassDetails'

const mapStateToProps = state => ({
  passDetails: state.passes.passDetails,
  actionRequired: state.passes.actionRequired
})

export default connect(mapStateToProps, null)(PassDetails)



// WEBPACK FOOTER //
// ./src/components/Passes/PassDetails/index.jsx